<template>
    <div class="container">
        <app-header></app-header>
        <h2>Пользователи</h2>
        <form>
            <div class="form-group">
                <label for="exampleInputEmail1">Имя</label>
                <input required type="text" v-model="name" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Имя">
                <label for="exampleInputEmail1">Логин</label>
                <input required type="email" v-model="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Логин">
                <label for="exampleInputEmail1">Пароль</label>
                <input required type="text" v-model="password" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Пароль">
            </div>
            <button @click.prevent="addUser()" type="submit" class="btn btn-primary">Добавить пользователя</button>
        </form>
        <table>
            <tr>
                <th style="min-width: 50px;">Id</th>
                <th>Пользователи</th>
                <th>Логин</th>
                <th style="text-align:center; min-width: 70px;">Дествия</th>
            </tr>
            <tr v-show="item.is_admin !== 1" v-for="item in ADMIN_USERS.data" :key="item.id">
                <td style="min-width: 50px;">{{item.id}}</td>
                <td>{{item.name}}</td>
                <td>{{item.email}}</td>
                <td style="text-align:center; min-width: 70px; color: red;">
                    <i style="cursor: pointer" @click="deleteUser(item.id)" class="fas fa-trash-alt"></i>
                </td>
            </tr>
        </table>
        <modal-box :title="title" v-if="box" @close="box = false"></modal-box>
    </div>
</template>

<script>
    import AppHeader from '@/components/header/'
    import {mapGetters} from 'vuex'
    import ModalBox from '@/components/modalbox'
    export default {
        data() {
            return {
                email: '',
                password: '',
                name: '',
                box: false,
                title: ''
            }
        },
        computed: {
            ...mapGetters([
                'ADMIN_USERS'
            ])
        },
        methods: {
            addUser() {
                this.$store.dispatch('POST', [
                    {
                        name: this.name,
                        email: this.email,
                        password: this.password
                    },
                    { name: 'post_users' }
                ])
                this.title = 'Пользователь создан!';
                this.box = true;
                this.repeat();
                this.email = '';
                this.password = '';
                this.name = '';
            },
            deleteUser(id){
                let ask = confirm('Вы точно хотите удалить пользователя?');
                if(ask){
                    this.$store.dispatch('DELETE', [
                        { id: id },
                        { name: 'admin_users'}
                    ])
                    this.title = 'Пользователь удален!';
                    this.box = true;
                    this.repeat();
                }
            },
            repeat(){
                setTimeout(() => {
                    this.$store.dispatch('GET', [
                        { },
                        { name: 'admin_users' }
                    ]);
                }, 500);
            }
        },
        components: {
            AppHeader,
            ModalBox
        },
        created () {
            this.repeat();
        },
    }
</script>

<style scoped>
    td{
        border: 1px solid #151515;
        min-width: 500px;
    }
    .header-section{
        background: #3A3B40;
    }
    .container{
        margin-top: 120px;
    }
    
</style>